import { PractitionerReceptionServiceUpdateCommand } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { Money } from '@dreryk/money-common-api';
import { ReceptionServiceDuration } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { receptionServiceTranslationKeys } from '../../../translations';
import { receptionServicePriceVisitor } from '../../shared/form/components/price/receptionServicePrice.utils';

import { PractitionerReceptionServiceUpdateFormBean } from './PractitionerReceptionServiceUpdateForm';

type PractitionerReceptionServiceUpdateActionRenderProps = {
   updatePractitionerReceptionService: (formData: PractitionerReceptionServiceUpdateFormBean) => Promise<void>;
};

type PractitionerReceptionServiceUpdateActionProps = {
   children: (renderProps: PractitionerReceptionServiceUpdateActionRenderProps) => JSX.Element;
   onSuccess: VoidFunction;
};

export const PractitionerReceptionServiceUpdateAction = (
   props: PractitionerReceptionServiceUpdateActionProps
): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, PractitionerReceptionServiceUpdateFormBean>(
      (parameters) => {
         const command = new PractitionerReceptionServiceUpdateCommand();
         command.receptionServiceId = parameters.id;
         command.parameters = {
            practitionerId: parameters.practitioner!.id,
            usingDefaultConfiguration: parameters.usingDefaultConfiguration,
         };

         if (!parameters.usingDefaultConfiguration) {
            receptionServicePriceVisitor(parameters)({
               asFree: () => {
                  command.parameters.minPrice = Choice.of(Money.of(0));
                  command.parameters.maxPrice = Choice.of(Money.of(0));
               },
               withPrice: ({ price }) => {
                  command.parameters.minPrice = Choice.of(Money.of(price!));
                  command.parameters.maxPrice = Choice.of(Money.of(price!));
               },
               withPriceRange: ({ priceRange }) => {
                  command.parameters.minPrice = Choice.of(Money.of(priceRange!.min));
                  command.parameters.maxPrice = Choice.of(Money.of(priceRange!.max));
               },
            });

            command.parameters.estimatedDuration = Choice.of(
               ReceptionServiceDuration.ofMinutes(parameters.estimatedDuration!)
            );
         }

         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(receptionServiceTranslationKeys.update.modal.confirmationText);
            props.onSuccess();
         },
      }
   );

   return props.children({
      updatePractitionerReceptionService: executeAsync,
   });
};
